module.exports = __webpack_public_path__ + "img/sunken-treasures.e260acd4.webp";